export default {
  attachments: 'Pièce jointe (facultatif)',
  attachmentButton: 'Choisir',
  attachmentLabel: 'Maximum {{fileSize}} Mo par fichier ({{filesAuthorized}})',
};
